import { Component } from 'js-component-framework';
import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * Component for the Animation of blocks.
 */
export default class Animation extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.setupAnimation();
  }

  setupAnimation() {
    const {
      animatedBlocks,
    } = this.children;
    const prefersReducedMotion = window
      .matchMedia('(prefers-reduced-motion: no-preference)');

    if (prefersReducedMotion.matches) {
      animatedBlocks.forEach((block) => {
        const animationType = block.getAttribute('data-animation-type');
        block.setAttribute('data-aos', animationType);
      });

      AOS.init({
        duration: 1000,
        offset: 250,
      });
    }
  }
}
